export default __webpack_public_path__ + "static/media/spinner_150.40e30d96.gif";